import { Box, Button, Grid2, IconButton, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider'
import { useFacilityList } from '../../assets/api/useAdminApi'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
// import api from '../../assets/api/useStudentPostApi'
import { Grid_Gap } from '../../shared/constants'
import useAuthStore from '../../store/useAuthStore'
import FacilityListTable from './FacilityListTable'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import { useMemo, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear';
import { useApartmentFacility, useCityviseApartment } from '../../assets/api/useMarketingExecutive'
import AdminToolbar from '../admin/components/AdminToolbar'
import UtItem from '../../shared/utils/UtList'
import api from '../../assets/nodeApi/axiosInstance'

const FacilityList = () => {
  const { data: facilityList, isLoading } = useFacilityList()
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFacility, setSelectedFacility] = useState([])
  const queryClient = useQueryClient();
  const { token, user } = useAuthStore()
  const { data: facilityApartmentList, isLoading: isFacilityApartmntLoading } = useApartmentFacility()
  const { data: CityApartmentList, isLoading: isCityApartmentListLoading } = useCityviseApartment({ zone_id: user?.zone_id })
  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };
  const originalRow = useMemo(() => {
    return facilityApartmentList?.map((item, index) => ({
      id: item?.id || index + 1,
      sr_no: index + 1,
      ...item
    })) || [];
  }, [facilityApartmentList]);
  const filteredRows = useMemo(() => {
    if (!searchQuery.trim()) {
      return originalRow;
    }

    const lowercasedQuery = searchQuery.toLowerCase();
    return originalRow.filter(student =>
      Object.values(student).some(val =>
        val != null && val.toString().toLowerCase().includes(lowercasedQuery)
      )
    );
  }, [originalRow, searchQuery]);
  const ApartmentOption = CityApartmentList?.data?.map((item, index) => ({
    id: item?.id,
    value: item?.apartment_name,
    label: item?.apartment_name

  })) || [];


  const facilityOption = facilityList?.map((item, index) => ({
    id: item?.id,
    value: item?.name,
    label: item?.name
  })) || [];
  const facilities = facilityOption.map(option => {
    const isSelected = selectedFacility.some(facility => facility.id === option.id);
    return {
      facility_id: option.id,
      is_available: isSelected ? "yes" : "no",
      status: isSelected ? "active" : "inactive"
    };
  });

  const validationSchema = Yup.object().shape({
    apartment_id: Yup.string().required('Apartment is required'),
  });
  const initialValues = {
    apartment_id: "",
    facility_id: ""
  };
  const { showToaster } = useToaster();
  const handleRemove = (id) => {
    setSelectedFacility(prev => prev.filter(apartment => apartment.id !== id));
  };
  const mutation = useMutation({
    mutationFn: (formData) => api.post("apartment-facilities", formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
  });
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    if (selectedFacility.length === 0) {
      showToaster('At least one facility must be selected', 'Warning', 'warning');
      setSubmitting(false);
      return;
    }

    const data = {
      apartment_id: values.apartment_id,
      facilities
    };
    mutation.mutate(data, {
      onSuccess: (response) => {
        showToaster('Success', response?.data?.message, 'success')
        queryClient.invalidateQueries({ queryKey: ['apartment-facilities'] });
        resetForm();
        setSelectedFacility([])
      },
      onError: (error) => {
        showToaster(error?.response?.data?.message || "Something Went wrong While submiting Form", 'Error', 'error')
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });

  }

  return (
    <Box>

      <CustomDivider />
      <NormalContainerWithHeader headerText={"Facility Form"}>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {() => (
            <Form>
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  mb: 5
                }}
              >
                {selectedFacility?.map((item, index) => (
                  <UtItem key={index} text={item?.label} onRemove={() => { handleRemove(item?.id) }} />
                ))}
              </Box>

              <Grid2 container spacing={Grid_Gap}
              > <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                  <Field
                    name="apartment_id"
                    component={IdAutoCompleteField}
                    options={ApartmentOption}
                    label="Select Apartment"
                    isRequired={true}
                    isLoading={isCityApartmentListLoading}
                  />
                </Grid2>

                <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                  <Field
                    name="facility_id"
                    component={IdAutoCompleteField}
                    options={facilityOption}
                    label="Facility Option"
                    isRequired={true}
                    isLoading={isLoading}
                    onValueChange={(newValue) => {
                      setSelectedFacility((prev) => {
                        const exists = prev?.find((item) => item?.id === newValue?.id);
                        return exists ? prev : [...prev, newValue];
                      });

                    }}
                  />
                </Grid2>

              </Grid2>
              <CustomDivider />
              <Grid2 container spacing={Grid_Gap}>
                <Grid2 children size={{ xs: 6, md: 4 }}>
                  <Button variant='contained' type='submit' fullWidth>Submit</Button>
                </Grid2>
              </Grid2>
            </Form>
          )}
        </Formik>
        <CustomDivider />
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader headerText={"Apartments List"}
        RightContent={
          <AdminToolbar
            onSearchChange={handleSearchChange}
          // onFilterClick={handleClickOpen}
          // filterIcon={Constants.customImages.FilterDark}

          />
        }
      >
        <FacilityListTable facilityRows={filteredRows} isLoading={isFacilityApartmntLoading} />
      </NormalContainerWithHeader>

    </Box>
  )
}

export default FacilityList